import { getAuthHeaders } from "./authService.js";

const domain = process.env.REACT_APP_DOMAIN;

export async function fetchStages() {
  const res = await fetch(`${domain}/api/v1/lead-stages/`, {
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Failed to fetch stages");
  return data;
}

export async function createStage({ stage_label, stage_type = "in_progress" }) {
  const res = await fetch(`${domain}/api/v1/lead-stages/`, {
    method: "POST",
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ stage_label, stage_type }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Failed to create stage");
  return data;
}

export async function updateStage(stageId, { stage_label, stage_type, sort_order, color, dashboard_order }) {
  const res = await fetch(`${domain}/api/v1/lead-stages/${stageId}`, {
    method: "PUT",
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ stage_label, stage_type, sort_order, color, dashboard_order }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Failed to update stage");
  return data;
}

export async function toggleStageDashboard(stageId) {
  const res = await fetch(`${domain}/api/v1/lead-stages/${stageId}/toggle-dashboard`, {
    method: "PUT",
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Failed to toggle");
  return data;
}

export async function deleteStage(stageId) {
  const res = await fetch(`${domain}/api/v1/lead-stages/${stageId}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Failed to delete stage");
  return data;
}
